<div class="scope-filter">
    <mat-chip-listbox [value]="scope" (change)="setScope($event.value)" aria-label="Which tasks to show">
        <mat-chip-option value="mine" [selectable]="scope !== 'mine'" matTooltip="Tasks assigned to you or to everyone">
            <mat-icon matChipAvatar>person</mat-icon>Mine</mat-chip-option>
        <mat-chip-option value="all" [selectable]="scope !== 'all'" matTooltip="Every task in the practice">
            <mat-icon matChipAvatar>groups</mat-icon>Everyone</mat-chip-option>
    </mat-chip-listbox>
</div>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<ng-container *ngIf="filteredTasks.length > 0; else noResults">
    <ng-container *ngFor="let status of statusOptions; let i = index">
        <div class="list-header expandable" (click)="toggleStatusOption(status)" [class.m-t-5]="i === 0">
            {{ status }} ({{filteredTasksByStatus[status]?.length || 0}})
            <mat-icon aria-hidden="false">
                {{ expandedStatus === status ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <mat-list @expandCollapse *ngIf="expandedStatus === status">

            <mat-list-item *ngFor="let task of filteredTasksByStatus[status]" (click)="loadTask(task)"
                class="auto-height" [appPatientValidationStatus]="task.Patient ?? {}"
                #valStatus="appPatientValidationStatus" [appPatientActive]="task.Patient.id">
                <div class="list-item stack-mobile">
                    <div class="list-item-details">
                        <app-patient-validation-messages [valStatus]="valStatus"> </app-patient-validation-messages>
                        <div matLine class="patient-name">
                            <b>{{ task.Patient.surname }}, {{ task.Patient.name }}</b>
                            <span class="patient-number" *ngIf="task.Patient.patientNumber">({{
                                task.Patient.patientNumber
                                }})</span>
                        </div>
                        <div matLine class="task">
                            <div class="full-height">
                                <div class="task-status-indicator" [ngClass]="task.status.toLowerCase()"
                                    [matTooltip]="'Task status is ' + task.status">
                                </div>
                            </div>
                            <span>{{ task.task }}</span>
                        </div>
                        <div matLine class="note-footer">
                            <span *ngIf="task.dueDate">Due: {{ task.dueDate | date : 'dd/MM/yyyy'}} · </span>
                            <span class="assignees">Assigned to: {{ assigneeSummary(task) }}</span>
                        </div>
                    </div>
                    <div class="action-icons keep-colors">
                        <button mat-icon-button color="primary" *ngIf="task.status !== 'Completed'"
                            (click)="updateTaskStatus($event, task, 'Completed')"
                            matTooltip="Mark task as completed">
                            <mat-icon>check_circle</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" *ngIf="task.status !== 'Pending'"
                            (click)="updateTaskStatus($event, task, 'Pending')" matTooltip="Mark task as pending">
                            <mat-icon>pending_actions</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" *ngIf="task.status !== 'Cancelled'"
                            (click)="updateTaskStatus($event, task, 'Cancelled')"
                            matTooltip="Mark task as cancelled">
                            <mat-icon>cancel</mat-icon>
                        </button>
                        <button mat-icon-button (click)="navigateToPatientFile($event, task.Patient.id)"
                            matTooltip="Load the patient file">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </div>
                </div>

            </mat-list-item>
        </mat-list>
    </ng-container>
    <div class="mobile-spacer"></div>

</ng-container>



<ng-template #noResults>
    <p class="no-records-message" *ngIf="!loading">No tasks found.</p>
</ng-template>